export const URL = "https://catchmyseat.com/webapi/";
export const UPLOADS="https://catchmyseat.com/uploads/";
/*export const URL = "http://192.168.29.221/catchmyseat/webapi/";
export const UPLOADS="http://192.168.29.221/catchmyseat/uploads/";*/
export const EBKEY = "1U3UZ5P21O";
